<template>
    <div v-if="!onePaymentMethod" class="alternate-form-payment">
        <button
            v-for="option in options"
            :key="option"
            type="button"
            class="alternate-form-payment__button"
            :class="option === value ? 'alternate-form-payment__button--selected' : ''"
            @click="updateValue(option)"
        >
            {{ option }}
        </button>
    </div>
</template>

<script>
import './alternate-form-payment.scss';

export default {
    name: 'AlternateFormPayment',
    props: {
        value: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: function() {
                return [];
            },
            required: true,
        },
    },
    computed: {
        onePaymentMethod() {
            return this?.options.length === 1;
        },
    },
    created() {
        if (!this.value) this.$emit('input', this?.options[0]);
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value);
        },
    },
};
</script>
